import React from 'react';
import { Team, VetoStep } from '../../types/match.types';
import { mapImages } from '../../utils/matchHelpers';

interface VetoSectionProps {
  vetoSteps: VetoStep[];
  mapPool: string[];
}

const getMapImage = (map: string): string => {
  return mapImages[map] || "/images/maps/default.jpg";
};

const getTeamLogoUrl = (team: Team) => {
  if (team && team.teamId) {
    return `https://api.ncseries.gg/api/Team/${team.teamId}/logo`;
  } else {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23333'/%3E%3Ctext x='50' y='50' font-size='18' text-anchor='middle' alignment-baseline='middle' font-family='sans-serif' fill='%23fff'%3ENo Logo%3C/text%3E%3C/svg%3E";
  }
};

const VetoSection: React.FC<VetoSectionProps> = ({ vetoSteps, mapPool }) => {
  const renderVetoMaps = () => {
    const orderedMaps: string[] = [];
    const mapOrder: Map<string, number> = new Map();
    const mapActions: Map<string, VetoStep> = new Map();
    const mapSides: Map<string, VetoStep> = new Map();

    vetoSteps.forEach((step, index) => {
      if (step.type !== "side" && !mapOrder.has(step.map)) {
        mapOrder.set(step.map, index);
        orderedMaps.push(step.map);
        mapActions.set(step.map, step);
      } else if (step.type === "side") {
        mapSides.set(step.map, step);
      }
    });

    mapPool.forEach((map) => {
      if (!mapOrder.has(map)) {
        orderedMaps.push(map);
      }
    });

    return orderedMaps.map((map) => {
      const action = mapActions.get(map);
      const sideInfo = mapSides.get(map);
      const orderNumber = mapOrder.has(map) ? mapOrder.get(map)! + 1 : "";

      const actionLabel = action
        ? action.type === "ban"
          ? "BANNED"
          : action.type === "pick"
          ? "PICKED"
          : action.type === "decider"
          ? "DECIDER"
          : ""
        : "";

      return (
        <div key={map} className={`veto-map-tall ${action ? action.type : ""}`}>
          <div className="map-image-tall">
            <img src={getMapImage(map)} alt={map} />

            {orderNumber && (
              <div className="map-order-number">{orderNumber}</div>
            )}

            {sideInfo && sideInfo.side && sideInfo.team && (
              <div className="map-side-info">
                <div
                  className={`side-indicator ${
                    sideInfo.side === "CT" ? "ct-side" : "t-side"
                  }`}
                >
                  {sideInfo.team.teamName} starts {sideInfo.side}
                </div>
              </div>
            )}

            {action && (
              <div className={`map-status ${action.type}`}>
                <div className="status-label">{actionLabel}</div>
                {action.team && (
                  <div className="team-info">
                    <img
                      src={action.team.teamLogo || getTeamLogoUrl(action.team)}
                      alt={action.team.teamName}
                      className="team-logo"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src =
                          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23333'/%3E%3Ctext x='50' y='50' font-size='18' text-anchor='middle' alignment-baseline='middle' font-family='sans-serif' fill='%23fff'%3ENo Logo%3C/text%3E%3C/svg%3E";
                      }}
                    />
                    <span className="team-name" title={action.team.teamName}>
                      {action.team.teamName}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={`map-name ${action ? action.type : ""}`}>{map}</div>
        </div>
      );
    });
  };

  return (
    <div className="veto-wide-container">
      <div className="veto-section-visual">
        <div className="veto-maps-tall">
          {renderVetoMaps()}
        </div>
      </div>
    </div>
  );
};

export default VetoSection;